import apiClient from '../config/axiosConfig'; // eslint-disable-line

export const checkProjectConfig = (projectId) => { 
    return apiClient.get(`/v2/projects/${projectId}/checklatest`); 
};

export const publishProject = (projectId) => {
    return apiClient.put(`/v2/projects/${projectId}/versions/publishVersion/latest`);
};
